<template>
    <modal id="training-progress-modal"
           size="large"
           v-model="showModal"
           :title="this.$t('employee_list')"
           :cancel-btn-label="$t('close')"
           :hide-submit-button="true"
           @submit=""
           :preloader="preloader">

        <div class="d-flex flex-column justify-content-center mb-primary border-bottom">
            <h3 class="text-center">
                {{ department.name }}
            </h3>
            <p class="text-center">{{ $t('total_employee') }} - {{employees.length}} </p>
        </div>

        <app-pre-loader v-if="loading"/>

        <template v-else>
            <template v-if="employees.length">
                <div class="mb-3">
                    <input
                        v-model="searchTerm"
                        type="text"
                        class="form-control"
                        placeholder="Search by name, email or designation"
                    />
                </div>

                <div class="table-responsive">
                    <table class="table table-borderless align-middle mb-0">
                        <thead>
                        <tr>
                            <th>{{ $t('employee') }}</th>
                            <th>{{ $t('designation') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="user in paginatedEmployees" :key="user.id" class="border-bottom">
                            <td>
                                <app-user-media :value="user.profile_picture" :row-data="user"/>
                            </td>
                            <td>{{ designationName(user) }}</td>
                        </tr>
                        <tr v-if="!filteredEmployees.length">
                            <td colspan="2" class="text-center text-muted py-4">No matching employees</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="filteredEmployees.length > perPage" class="d-flex justify-content-between align-items-center mt-3">
                    <small class="text-muted">{{ filteredEmployees.length }} {{ $t('employee') }}</small>
                    <app-pagination :total-row="filteredEmployees.length" :row-limit="perPage" @submit="goToPage"/>
                </div>
            </template>
            <h6 v-else class="text-center m-primary">{{ $t('this_department_has_no_employee') }}</h6>
        </template>

    </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "DepartmentEmployee",
    mixins: [ModalMixin],
    props: {
        department: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            employees: [],
            loading: true,
            searchTerm: '',
            currentPage: 1,
            perPage: 8,
        }
    },
    mounted() {
        this.getDepartmentEmployees();
    },
    computed: {
        filteredEmployees() {
            const term = this.searchTerm.trim().toLowerCase();
            if (!term) return this.employees;
            return this.employees.filter(user => {
                const designation = (user.designations && user.designations.length) ? user.designations[0].name : '';
                return `${user.first_name || ''} ${user.last_name || ''} ${user.email || ''} ${designation}`
                    .toLowerCase().includes(term);
            });
        },
        paginatedEmployees() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.filteredEmployees.slice(start, start + this.perPage);
        }
    },
    watch: {
        searchTerm() {
            this.currentPage = 1;
            this.$hub.$emit('resetPaginationState', 1);
        }
    },
    methods: {
        getDepartmentEmployees() {
            axiosGet(`${this.apiUrl.DEPARTMENTS}/${this.department.id}/employees`).then(({data}) => {
                this.employees = data;
            }).catch(({response}) => {
                this.$toastr.e(response.data.message);
            }).finally(() => {
                this.loading = false;
            })
        },
        designationName(user) {
            return (user.designations && user.designations.length) ? user.designations[0].name : '—';
        },
        goToPage(page) {
            this.currentPage = page;
        },
    }
}
</script>

